import { createSelector } from 'reselect';
import { accountsDataSliceName } from '../reducers/AccountsData';
import { selectPortalId } from './portal.selectors';
export const selectAccountsDataState = ({
  [accountsDataSliceName]: accountsDataState
}) => accountsDataState;
const selectAccounts = createSelector(selectAccountsDataState, accountsDataState => accountsDataState.accounts);
const selectPinnedAccountIds = createSelector(selectAccountsDataState, accountsDataState => accountsDataState.pinnedAccountIds);
export const selectFilteredAccounts = createSelector([selectAccounts, selectPinnedAccountIds, selectPortalId], (basicAccounts, pinnedAccountIds, currentPortal) => {
  const pinnedAccountSet = new Set(pinnedAccountIds);
  const accountsExcludingCurrentPortal = basicAccounts.filter(account => account.id !== currentPortal);
  return accountsExcludingCurrentPortal.sort((a, b) => {
    if (pinnedAccountSet.has(a.id) && !pinnedAccountSet.has(b.id)) {
      return -1;
    }
    if (!pinnedAccountSet.has(a.id) && pinnedAccountSet.has(b.id)) {
      return 1;
    }
    return (a.name || '').localeCompare(b.name || '');
  });
});